module.exports = __webpack_public_path__ + "img/kk.a19240f6.svg";